import { jsx as _jsx } from "react/jsx-runtime";
import cn from 'classnames';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as ArrowLeft } from '../../assets/icons/arrow-left.svg';
import styles from './BackButton.module.scss';
const BackButton = ({ className, customCallback, extraCallback }) => {
    const navigate = useNavigate();
    function navigateBack() {
        if (extraCallback) {
            extraCallback();
        }
        if (customCallback) {
            customCallback();
        }
        else {
            navigate(-1);
        }
    }
    return (_jsx(ArrowLeft, { "data-testid": "backButton", className: cn(styles.element, className), onClick: navigateBack }));
};
export default BackButton;
